import { formatYaraTime } from "./cells";

// Rendered by ReactTableWrapper as `<expandConfig.subComponent row={row} />`,
// so it has to stay a component reference. One row per (file x rule) match the
// group is made of.
const YaraMatchesDetail = ({ row }) => {
  const matches = row?.original?.matches || [];
  const matchCount = row?.original?.match_count || matches.length;

  if (matches.length === 0) {
    return <div className="yara-results__detail">No match detail available.</div>;
  }

  return (
    <div className="yara-results__detail">
      <table className="yara-results__detail__table">
        <thead>
          <tr>
            <th>Host</th>
            <th>File</th>
            <th>Size</th>
            <th>SHA256</th>
            <th>Signature</th>
            <th>Rule</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {matches.map((match, index) => (
            <tr key={`${match.sha256 || match.file_path}-${match.yara_rule}-${index}`}>
              <td>
                <span className="yara-results__cell__primary">{match.hostname || "-"}</span>
                <span className="yara-results__cell__secondary">
                  {[match.username, match.local_ip].filter(Boolean).join(" · ") || "-"}
                </span>
              </td>
              <td>
                <span className="yara-results__cell__primary">{match.file_name || "-"}</span>
                <span className="yara-results__cell__secondary" title={match.file_path}>
                  {match.file_path || "-"}
                </span>
              </td>
              <td>{match.file_size || "-"}</td>
              <td className="yara-results__detail__hash" title={match.sha256}>
                {match.sha256 || "-"}
              </td>
              <td>
                <span className="yara-results__cell__primary">{match.signature_status || "-"}</span>
                <span className="yara-results__cell__secondary" title={match.signer}>
                  {match.signer || "-"}
                </span>
              </td>
              <td>
                <span className="yara-results__cell__primary">{match.yara_rule || "-"}</span>
                <span className="yara-results__cell__secondary">
                  {`weight: ${match.rule_weight || 0}`}
                </span>
              </td>
              <td>{formatYaraTime(match.timestamp)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {matches.length < matchCount ? (
        <p className="yara-results__detail__note">
          {`Showing first ${matches.length} of ${matchCount} matches.`}
        </p>
      ) : null}
    </div>
  );
};

export default YaraMatchesDetail;
